import React, { useEffect } from 'react';
import { achievementDefinitions } from '../data/achievements';

interface AchievementToastProps {
  achievementId: string | undefined;
  onDismiss: () => void;
}

const AchievementToast: React.FC<AchievementToastProps> = ({ achievementId, onDismiss }) => {
  useEffect(() => {
    if (!achievementId) return;
    const timer = setTimeout(onDismiss, 3000);
    return () => clearTimeout(timer);
  }, [achievementId, onDismiss]);

  if (!achievementId) return null;

  const def = achievementDefinitions.find((a) => a.id === achievementId);
  if (!def) return null;

  return (
    <div className={`achievement-toast achievement-slide-in rarity-border-${def.rarity.toLowerCase()}`}>
      <span className="achievement-toast-icon">{def.icon}</span>
      <div className="achievement-toast-text">
        <span className="achievement-toast-title">Achievement Unlocked!</span>
        <span className="achievement-toast-name">{def.name}</span>
      </div>
    </div>
  );
};

export default AchievementToast;
